import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { Stack, Typography, Card } from '@mui/material';
import React from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from '../../common/LocalizationProvider';
import { altitudeConverter } from '../../common/utils/unitConverter';
import { selectSession } from '../../createSelectorUtils';

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(1, 0),
  color: theme.palette.warning.dark,
  backgroundColor: theme.palette.warning.lighter
}));

AerosDetailsGeographiqueInfos.propTypes = {
  aero: PropTypes.object
};
export default function AerosDetailsGeographiqueInfos({ aero }) {
  const t = useTranslation();
  const session = useSelector(selectSession);

  const { alti, lat, lon } = aero;
  return (
    <RootStyle>
      <Stack direction="column">
        <Typography variant="h5" paddingTop={1}>
          {t('geographique_infos')}
        </Typography>
      </Stack>
      <Stack sx={{ p: 3 }} spacing={0.25}>
        <Typography variant="h4">{altitudeConverter(alti, session.uniteAltitude)}</Typography>
        <Typography variant="subtitle2">{`${t('fields_Altitude')} (${
          session.uniteAltitude
        })`}</Typography>
      </Stack>
      <Stack sx={{ p: 1 }} spacing={0.25}>
        <Typography variant="h4">
          {lat ? lat.toFixed(4) : ''} , {lon ? lon.toFixed(4) : ''}
        </Typography>
        <Typography variant="subtitle2">{t('fields_coordinates')}</Typography>
      </Stack>
    </RootStyle>
  );
}
